<template>
  <div class="">
    <ContentTop>
      <img
        src="../assets/images/question.png"
        alt=""
      />
      <span>下载报告</span>
    </ContentTop>
    <!-- <div class="head1"><img alt="" src="http://schools.wfcheck.cn/img/icon3.png"/>常见问题</div> -->
    <div class="ck-content report-cont main step">
      <div class="query">
        <ul>
          <li>
            <div class="q">Q: 论文查重系统检测可以检测哪些类别的文章？</div>
            <div class="a">A: 平台检测系统可检测涵盖所有中文类别，包括哲学、经济学、管理学、法学、社会科学、教育学、文学、艺术学、历史学、理学、工学、农学、医学、政治学、军事学等学科论文。</div>
          </li>
          <li>
            <div class="q">Q: 用户提交的论文会不会泄漏给第三方？</div>
            <div class="a">A: 平台遵守相关保密规定，承诺不会泄露用户提交的论文。如果平台论文泄露了用户的论文，将承担法律责任，用户有权利追究。</div>
          </li>
          <li>
            <div class="q">Q: 查重完成后，是否以后就是一直是这个结果？</div>
            <div class="a">A: 当然不是，论文查重系统每过段时间会进行更新文献库，如果两次查重的时间间隔太久自然结果会不一样，所以建议两次的查重的间隔不要太长，当然现在查重系统有互联网文献库，有时候上午查重的，下午的结果就不一样了。所以遇到这个问题不是系统出问题了，是因为论文查重系统又出现更新了，只能继续修改。</div>
          </li>
          <li>
            <div class="q">Q: 0相似度是否正常？</div>
            <div class="a">A: 如检测结果为0，说明官网检测结果也是0，并非未检测，并非不准。只能说明你的论文在该检测系统的比对库里中没有重复的，即使您去官网检测也是这个结果。</div>
          </li>
          <li>
            <div class="q">Q: 在重复的句子中修改几个字能降低重复率？</div>
            <div class="a">A: 像万方系统的最小检测单位是句子，对句子也有相应的处理，有一个句子相似性的算法。并不是句子完全一样才判断为相同。句子有句子级的相似算法，段落有段落级的相似算法，计算一篇文献，一段话是否与其他文献文字相似，是在此基础上综合得出的。</div>
          </li>
          <li>
            <div class="q">Q: 数据，图表、图片参与查重吗？</div>
            <div class="a">A: 一般我们常见的论文查重系统，都是只对文字进行比对，表格本身也是文字，所以基本上各大系统都支持，而图片的比对目前所有系统都支持的很不好，部分系统会把图片先转换成文字后再进行查重比对，但若是图片本身并非文字或者图片不清晰，则在转换的过程中会出现各种错误与乱码，所以在与数据库进行比对的时候是不准确的。为了尽量保证查重的正确率，万方暂时不对图片进行查重。</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import { Row, Col } from 'ant-design-vue'
import ContentTop from '@/components/ContentTop'
export default {
  components: {
    ContentTop,
    // ARow:Row,
    // ACol:Col,
  },
  data () {
    return {
        
    }
  },
 
}
</script>

<style lang="less" scoped>
.basic-content {
  height: 100%;
  // .ck-content {
  //   margin-left: 12%;
  //   margin-right: 18%;
  // }
}
.head1 {
  height: 43px;
  background-color: #006DBF;
  background-size: 100% 100%;
  margin-top: 20px;
  text-align: left;
  line-height: 42px;
  padding: 0 20px;
  font-size: 18px;
  color: #fff;
  img {
    display: inline-block;
    vertical-align: middle;
    margin-top: -4px;
    margin-right: 10px;
  }
}
.main {
  background-color: #fafafa;
  position: relative;
  z-index: 1000;
  padding: 30px 20px;
}
.query {
  text-align: left;
}
ul li {
  margin-bottom: 30px;
}
.q{
  font-size: 16px;
  color: #006dbf;
  font-weight: 700;
  line-height: 32px;
}
</style>